module.exports = __webpack_public_path__ + "img/social-media-color-blocks-chevy.9b9b6786.png";